export enum severity {
    success = 'success',
    info = 'info',
    warn = 'warn',
    error = 'error',
}

// export enum sticky {
//     open = 'true',
//     close = 'false',
// }

// export enum position {
//     center ='tc',
//     right ='tr',
//     left ='tl',
// }

// export enum life {
//     life = 0
// }